export default __webpack_public_path__ + "static/media/Userhead.97b0aa03.png";